export default __webpack_public_path__ + "media/images/filter-stripes-60fd7528541a83f4b6db70de76e13a9e.svg";